import '@styles/scaffholding.css';

import React, { useRef } from 'react';
import { useAnimation } from '@util/useAnimation';
import Header from './Header';

import styles from './index.module.css';

const Layout = ({ children }) => {
    const canvas = useRef(null);
    useAnimation(canvas);
    return (
        <div>
            <canvas
                ref={canvas}
                width="100%"
                height="100%"
                className={styles.canvas}
            />
            <div className={styles.site}>
                <Header />
                {children}
            </div>
        </div>
    );
};

export default Layout;
